import isEmpty from "is-empty";
import React, { useEffect, useState } from "react";
import { getBrochuresQuery } from "rsl-api-106/lib/queries";
import { Query, QueryGetBrochuresArgs } from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import { useSession } from "@hooks";

import { SelectOptionType } from "../../../../types";
import Select from "../Select";
import { SelectProps } from "../Select/Select";

interface SelectBookletProps extends SelectProps {
  //
}

const languagesVarsCodes = [
  "LANG_neobooking_booklet_choose", //Choisir une brochure
  "LANG_neobooking_booklet_loading", //Chargement des brochures...
];

const SelectBooklet: React.FC<SelectBookletProps> = ({ ...props }) => {
  /* Hooks */
  const { sessionId, getLanguageVarValue } = useSession();
  const { data, error, loading } = useQuery<Query, QueryGetBrochuresArgs>(
    getBrochuresQuery(),
    {
      variables: { session: { name: sessionId!! } },
    }
  );

  /* State */
  const [bookletsOptions, setBookletsOptions] = useState<SelectOptionType[]>(
    []
  );

  useEffect(() => {
    if (data && data.getBrochures?.brochureList) {
      const options: SelectOptionType[] =
        data.getBrochures.brochureList?.map((x) => {
          return {
            value: x?.code as string,
            label: x?.label as string,
          };
        }) ?? [];
      setBookletsOptions(options);
    }
  }, [data]);

  return (
    <>
      <Select
        placeholder={
          props.placeholder
            ? props.placeholder
            : getLanguageVarValue("LANG_neobooking_booklet_choose")
        }
        loadingPlaceholder={
          props.loadingPlaceholder
            ? props.loadingPlaceholder
            : getLanguageVarValue("LANG_neobooking_booklet_loading")
        }
        empty={bookletsOptions && isEmpty(bookletsOptions)}
        {...props}
        options={bookletsOptions}
      />
    </>
  );
};

SelectBooklet.propTypes = {
  //
};

export default SelectBooklet;
